// src/app/auth/authFlowConfig.js
const _isTrue = (v) => {
  const s = String(v ?? '').trim().toLowerCase();
  return s === '1' || s === 'true' || s === 'yes' || s === 'on';
};

export const AUTH_FLOW = {
  requireProject: _isTrue(process.env.REACT_APP_AUTH_REQUIRE_PROJECT),
  requireGroup: _isTrue(process.env.REACT_APP_AUTH_REQUIRE_GROUP),
  requireRole: _isTrue(process.env.REACT_APP_AUTH_REQUIRE_ROLE)
};

export default AUTH_FLOW;
